import { Table } from 'antd'
import { useContext } from 'react'

import { useExcelFileUploaderStore } from '@/stores/import/excelFileUploaderStore'

import {
  ExcelFileUploaderContext,
  ExcelFileUploaderContextType,
} from '../ExcelFileUploader/ExcelFileUploader'
import cn from './ExcelFilePreviewDataTable.module.scss'

function ExcelFilePreviewDataTable() {
  const { previewDataColumns, visiblePreviewData, handleScrollPreviewData } =
    useContext(ExcelFileUploaderContext) as ExcelFileUploaderContextType

  const { currentIncludedSheet } = useExcelFileUploaderStore((state) => state)

  return (
    <div className={cn.excelFilePreviewDataTable}>
      <Table
        size="small"
        columns={previewDataColumns[currentIncludedSheet]}
        dataSource={visiblePreviewData[currentIncludedSheet]}
        pagination={false}
        rowKey="__rowKey"
        onScroll={handleScrollPreviewData}
        scroll={{ x: 'max-content', y: 7 * 90 }}
      />
    </div>
  )
}

export default ExcelFilePreviewDataTable
